import { render, staticRenderFns } from "./ManageStages.vue?vue&type=template&id=2a7ea525&scoped=true&"
import script from "./ManageStages.vue?vue&type=script&lang=js&"
export * from "./ManageStages.vue?vue&type=script&lang=js&"
import style0 from "./ManageStages.vue?vue&type=style&index=0&id=2a7ea525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ea525",
  null
  
)

export default component.exports